import { render, staticRenderFns } from "./CRUDTaskOrFolderDialog.vue?vue&type=template&id=f4f0dc62"
import script from "./CRUDTaskOrFolderDialog.vue?vue&type=script&lang=js"
export * from "./CRUDTaskOrFolderDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports